import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Intermediate_Check_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "01 Jan 2025",
      instrumentId: "INS101",
      instrumentName: "Coal Testing Machine",
      calibrateInstrument: "Weighing Balance",
      weightGrams: 0.01,
      stdValueGrams: 0.0103,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 0.0103,
      deviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS102",
      instrumentName: "Coal Testing Machine",
      calibrateInstrument: "Hot Air Oven",
      weightGrams: 0.02,
      stdValueGrams: 0.0202,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 0.0202,
      deviation: 0.0202,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS103",
      instrumentName: "Laboratory Moisture Analyzer",
      calibrateInstrument: "Muffle Furnace",
      weightGrams: 1.0,
      stdValueGrams: 1.004,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 1.004,
      deviation: 1.004,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS104",
      instrumentName: "Volatile Matter Tester",
      calibrateInstrument: "Ph Meter",
      weightGrams: 2.0,
      stdValueGrams: 2.003,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 2.003,
      deviation: 2.003,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS105",
      instrumentName: "Proximate Analyzer",
      calibrateInstrument: "Bomb Calorimeter",
      weightGrams: 5.0,
      stdValueGrams: 4.9993,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 4.9993,
      deviation: 4.9993,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS106",
      instrumentName: "Coal Testing Machine",
      calibrateInstrument: "Moisture Analyzer",
      weightGrams: 20.0,
      stdValueGrams: 19.999,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 19.999,
      deviation: 19.999,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS107",
      instrumentName: "Coal Testing Machine",
      calibrateInstrument: "Temperature Probe",
      weightGrams: 50.0,
      stdValueGrams: 49.9988,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 49.9988,
      deviation: 49.9988,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS108",
      instrumentName: "Laboratory Moisture Analyzer",
      calibrateInstrument: "Weighing Balance",
      weightGrams: 100.0,
      stdValueGrams: 99.9986,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 99.9986,
      deviation: 99.9986,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS109",
      instrumentName: "Volatile Matter Tester",
      calibrateInstrument: "Hot Air Oven",
      weightGrams: 2.0,
      stdValueGrams: 99.9986,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 99.9986,
      deviation: 99.9986,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS1010",
      instrumentName: "Proximate Analyzer",
      calibrateInstrument: "Muffle Furnace",
      weightGrams: 5.0,
      stdValueGrams: 2.003,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 2.003,
      deviation: 2.003,
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS1011",
      instrumentName: "Laboratory Moisture Analyzer",
      calibrateInstrument: "Ph Meter",
      weightGrams: 20.0,
      stdValueGrams: 2.003,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      mean: 2.003,
      deviation: 2.003,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowspan="2">
                  <input type="checkbox" />
                </th>
                <th rowspan="2">Date</th>
                <th rowspan="2">Instrument ID</th>
                <th rowspan="2">Instrument Name</th>
                <th rowspan="2">Calibrate Instrument</th>
                <th rowspan="2">Weight In Grams</th>
                <th rowspan="2">STD Value In Grams</th>
                <th colspan="5">Observations</th>
                <th rowspan="2">Mean</th>
                <th rowspan="2">Deviation</th>
              </tr>
              <tr>
                <th>OBS 01</th>
                <th>OBS 02</th>
                <th>OBS 03</th>
                <th>OBS 04</th>
                <th>OBS 05</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.instrumentId}</td>
                  <td>{row.instrumentName}</td>
                  <td>{row.calibrateInstrument}</td>
                  <td>{row.weightGrams}</td>
                  <td>{row.stdValueGrams}</td>
                  <td>{row.obs01}</td>
                  <td>{row.obs02}</td>
                  <td>{row.obs03}</td>
                  <td>{row.obs04}</td>
                  <td>{row.obs05}</td>
                  <td>{row.mean}</td>
                  <td>{row.deviation}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Intermediate_Check_Report_Table;
